<template>
  <div
    :class="[
      'SupportSection grid',
      this.$route.params.section,
      { isSupport, hasFlickity: page.slideshow },
    ]"
  >
    <nav v-if="isSupport" class="grid desktop pill-hover">
      <router-link to="/support/memberships" class="pill"
        >Memberships</router-link
      >
      <router-link to="/support/donations" class="pill">Donations</router-link>
      <router-link to="/support/sponsorships" class="pill"
        >Sponsorships</router-link
      >
      <a
        href="https://dublab.myshopify.com/"
        class="pill external"
        target="_blank"
        >Store</a
      >
    </nav>
    <nav v-if="isSupport" class="mobile">
      <select class="pill" v-model="navigation.active">
        <option v-for="(text, url) in navigation.links" :value="url" :key="url">
          {{ text }}
        </option>
      </select>
    </nav>
    <dublab-gallery
      v-if="page.slideshow"
      :images="page.slideshow"
      :extend="true"
    ></dublab-gallery>
    <div class="sidebar">
      <runtime-content :content="sidebarContent"></runtime-content>
    </div>
    <div class="content-container">
      <div class="content">
        <runtime-content :content="mainContent"></runtime-content>
        <div v-if="page.tabs">
          <form class="tabs">
            <div class="radio-group">
              <div v-for="(tab, key) in getTabs" class="radio-pill" :key="key">
                <input
                  type="radio"
                  :id="'tab-' + key"
                  :value="key"
                  name="tabs"
                  v-model="active"
                />
                <label :for="'tab-' + key">{{ tab.title }}</label>
              </div>
            </div>
            <select class="pill" v-model="active">
              <option v-for="(tab, key) in getTabs" :value="key" :key="key">
                {{ tab.title }}
              </option>
            </select>
          </form>
          <div v-if="getTabItems" :class="['tab-items', getTabItemsTemplate]">
            <AboutThumb
              v-for="item in getTabItems"
              :item="item"
              :template="getTabItemsTemplate"
              :key="item.title"
            ></AboutThumb>
          </div>
          <div v-if="getActive" class="tab-totals pill-hover">
            <div>Total: {{ getActive.title }}</div>
            <a v-if="getActive.link" :href="getActive.link" class="pill">{{
              getActive.link_text
            }}</a>
          </div>
        </div>
        <BoxDonate class="desktop"></BoxDonate>
      </div>
    </div>
  </div>
</template>

<script>
import delve from "dlv";
import { mixin } from "@/lib/content-state";

import DublabGallery from "@/components/DublabGallery";
import AboutThumb from "@/components/AboutThumb";
import BoxDonate from "@/components/BoxDonate";
import RuntimeContent from "@/components/RuntimeContent";

export default {
  name: "SupportSection",
  components: { DublabGallery, AboutThumb, BoxDonate, RuntimeContent },
  mixins: [mixin],
  data() {
    return {
      navigation: {
        active: this.$route.path,
        links: {
          "/support/memberships": "Memberships",
          "/support/donations": "Donations",
          "/support/sponsorships": "Sponsorships",
          "https://dublab.myshopify.com": "Store",
        },
      },
      active: null,
    };
  },
  watch: {
    "$route.path": function (value) {
      if (this.navigation.active !== value) {
        this.navigation.active = value;
      }
    },
    "navigation.active": function (value) {
      if (value.substring(0, 4) === "http") window.location = value;
      else this.$router.push(value);
    },
  },
  mounted() {
    // active

    // link jumping
    if (this.$route.hash) {
      const el = document.querySelector(this.$route.hash);
      if (el) {
        const { top } = el.getBoundingClientRect();
        window.scrollTo(0, top - 80);
      }
    }
  },
  computed: {
    isSupport() {
      return this.$route.name === "support";
    },
    getTabs() {
      return delve(this.page, "tabs.options");
    },
    getTabItems() {
      if (delve(this.page, "tabs.entries")) {
        return this.page.tabs.entries.filter((item) => {
          return item.level.indexOf(this.active) >= 0;
        });
      } else return null;
    },
    getActive() {
      if (delve(this.page, "tabs.options")) {
        // reset active to first tab if necessary
        const keys = Object.keys(this.page.tabs.options);
        if (keys.indexOf(this.active) < 0) this.resetActive(keys);

        // return active tab
        return this.page.tabs.options[this.active];
      } else return null;
    },
    getTabItemsTemplate() {
      return this.$route.params.section === "donations" ? "block" : "row";
    },
    sidebarContent() {
      return `<div class="copy pill-hover">${this.page.subcontent}</div>`;
    },
    mainContent() {
      return `<div class="copy">${this.page.content}</div>`;
    },
  },
  methods: {
    resetActive(keys) {
      this.active = keys[0];
    },
  },
};
</script>

<style scoped>
nav {
  grid-column: 1 / -1;
  padding: 0;
  top: 1rem;
  z-index: 5;
}

nav > * {
  grid-column: span 3;
}

.sidebar {
  grid-column: span 4;
  margin-top: 1rem;
}

.sidebar >>> img {
  max-width: min(100%, var(--intrinsic-width, 100%));
  margin-bottom: 2rem;
}

.sidebar >>> img.center {
  margin: 0 auto 2rem auto;
}

.content-container {
  grid-column: span 8;
  margin-top: 1rem;
}

.donate {
  margin-top: 3rem;
}

.row:not(:first-child) {
  margin-top: 2rem;
  padding-top: 2rem;
}

.content {
  padding-left: 6.5%;
  padding-right: 6.5%;
}

.content > *:not(:first-child) {
  margin-top: 4rem;
}

.content .copy >>> .wp-caption {
  text-align: center;
  padding: 2rem 0;
}

.content .copy >>> img {
  max-width: min(100%, var(--intrinsic-width, 100%));
  display: block;
  margin: 0 auto;
}

/*.content .copy >>> .wp-caption,*/
.content .copy >>> ul,
.content .copy >>> ol {
  padding-left: 8%;
  padding-right: 8%;
}

.DublabGallery {
  grid-column: 1 / -1;
  margin-left: -2rem;
  margin-right: -2rem;
}

.tabs select {
  width: 100%;
}

.tab-items.row {
  padding-top: 0;
}

.tab-items.block {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr));
  grid-gap: 4rem 2rem;
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.tab-totals {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #000;
  padding-top: 2rem;
  margin-top: 2rem;
}

.tab-totals > div:first-child {
  font: var(--large);
}

.pill.router-link-active {
  background-color: var(--accent);
  color: white;
  border-style: solid;
}

select {
  display: none;
}

@media (min-width: 1000px) and (max-width: 1360px) {
  .SupportSection.memberships .radio-pill label {
    font-size: 0.8em;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
  }
}

@media (max-width: 1000px) {
  .grid {
    display: flex;
    flex-direction: column;
  }

  .grid > * + *:not(nav) {
    margin-top: 2.5rem;
  }

  nav > * {
    grid-column: 1 / -1;
  }
  .sidebar,
  .content-container {
    grid-column: 1 / -1;
  }
  .radio-group {
    display: none;
  }
  select {
    display: block;
  }

  .DublabGallery {
    order: 1;
  }
  .content-container {
    order: 2;
  }
  .sidebar {
    order: 3;
    margin-top: 4rem !important;
  }

  .isSupport .DublabGallery {
    grid-row: 2;
  }
  .isSupport .content-container {
    grid-row: 3;
  }
  .isSupport .sidebar {
    grid-row: 4;
  }

  .content {
    padding-left: 0%;
    padding-right: 0%;
  }

  .content .copy >>> ul,
  .content .copy >>> ol {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .tab-totals > div[data-v-80d6e9]:first-child {
    font: var(--medium);
  }
}

nav select {
  width: 100%;
}

.desktop {
}
.mobile {
  display: none;
}

@media (max-width: 1000px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
</style>
